export interface ThresholdsDTO {
  workshop_id: string;
  threshold_capacity: string;
  modified_at: string;
  modified_by: string;
}
export class ThresholdListDTO {
  constructor(public data: ThresholdsDTO[]) {}
}
